<app-item-list
  filterFormPlaceholder="John Doe"
  [addNewRouterLink]="addNewRouterLink"
  [addNewRouterState]="addNewRouterState"
  [canAddNew$]="canAddNew$"
  [items]="usersSubject"
  [searchMode]="searchMode"
  [filterFunction]="userMatchesFilter"
  (filteredSortedItems)="onFilterSortUpdate($event)"
  (manualSearch)="_manualSearch.emit($event)"
  >
  <table class="table table-striped">
    @if (!!caption) {
      <caption>{{ caption }}</caption>
    }
    <thead>
      <tr>
        <th appSortable="userName" scope="col">{{ 'content.user-id' | translate }}</th>
        <th appSortable="lastName" scope="col">{{ 'content.person.name' | translate }}</th>
        <th appSortable="creationDt" scope="col">{{ 'content.created' | translate }}</th>
        <th appSortable="lastLoginDt" scope="col">{{ 'content.last-logon' | translate }}</th>
        <th appSortable="status" scope="col">{{ 'content.status' | translate }}</th>
        <th scope="col">{{ 'content.options' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (user of filteredSortedUsers; track user) {
        <tr>
          <th scope="row">
            <a [routerLink]="['/admin/users', user.userName, 'details']" [state]="user" [attr.aria-label]="'content.view-details-for-something' | translate:{what:user.userName}">
              {{ user.userName }}
            </a>
            @if (authService.isMe(user) | async) {
              <span>({{ 'content.me' | translate }})</span>
            }
          </th>
          <td>{{ user.lastName }}, {{ user.firstName }}</td>
          <td>{{ reformatDate(user.creationDt) }}</td>
          <td>{{ reformatDate(user.lastLoginDt) }}</td>
          <td>{{ user.status }}</td>
          <td>
            @if (authService.isNotMe(user) | async) {
              <div class="inline-gap-3" #modalContainer>
                @if (guiPermissionsService.canResetPassword(user) | async) {
                  <app-icon-button
                    [ariaLabel]="'content.reset-password' | translate"
                    [icon]="faKey"
                    [tooltip]="'content.reset-password-for' | translate:{who:user.userName}"
                  (buttonClick)="reset(user, 'reset-user-dialog-label-' + userListId, modalContainer)"></app-icon-button>
                }
                @if (guiPermissionsService.canEditUser(user) | async) {
                  <app-icon-button element="link"
                    [ariaLabel]="'content.edit' | translate"
                    [icon]="faEdit"
                    [routerLink]="['/admin/users', user.userName, 'edit']"
                  [tooltip]="'content.edit-something' | translate:{what:user.userName}"></app-icon-button>
                }
                @if (usersService.isUserEnabled(user) && (guiPermissionsService.canDisableUser(user) | async)) {
                  <app-icon-button
                    [ariaLabel]="'content.disable' | translate"
                    [icon]="faUserAltSlash"
                    [tooltip]="'content.disable-something' | translate:{what:user.userName}"
                  (buttonClick)="disable(user, 'disable-user-dialog-label-' + userListId, modalContainer)"></app-icon-button>
                }
                @if (usersService.isUserDisabled(user) && (guiPermissionsService.canEnableUser(user) | async)) {
                  <app-icon-button
                    [ariaLabel]="'content.enable' | translate"
                    [icon]="faUserCheck"
                    [tooltip]="'content.enable-something' | translate:{what:user.userName}"
                  (buttonClick)="enable(user, 'enable-user-dialog-label-' + userListId, modalContainer)"></app-icon-button>
                }
                @if (guiPermissionsService.canTerminateUser(user) | async) {
                  <app-icon-button
                    [ariaLabel]="'content.terminate' | translate"
                    [icon]="faTrash"
                    [tooltip]="'content.terminate-something' | translate:{what:user.userName}"
                  (buttonClick)="terminate(user, 'terminate-user-dialog-label-' + userListId, modalContainer)"></app-icon-button>
                }
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
  <span id="reset-user-dialog-label-{{ userListId }}" class="d-none">{{ 'aria.confirm-reset-user-password-dialog' | translate }}</span>
  <span id="disable-user-dialog-label-{{ userListId }}" class="d-none">{{ 'aria.confirm-disable-user-dialog' | translate }}</span>
  <span id="enable-user-dialog-label-{{ userListId }}" class="d-none">{{ 'aria.confirm-enable-user-dialog' | translate }}</span>
  <span id="terminate-user-dialog-label-{{ userListId }}" class="d-none">{{ 'aria.confirm-terminate-user-dialog' | translate }}</span>
</app-item-list>
